'use client';

import { useState } from 'react';

import { VALUES } from '../../constants';
import { ValueCardDesktop } from '../value-card';

const INITIAL_CARD_INDEX = 0;

export const CardsDesktop = () => {
    const [currentCardIndex, setCurrentCardIndex] =
        useState(INITIAL_CARD_INDEX);
    const [previousCardIndex, setPreviousCardIndex] =
        useState(INITIAL_CARD_INDEX);

    const handleSelect = (index: number) => {
        setCurrentCardIndex(index);
    };

    const handleSpread = () => {
        if (currentCardIndex > previousCardIndex) {
            setPreviousCardIndex((prev) => prev + 1);
        } else {
            setPreviousCardIndex((prev) => prev - 1);
        }
    };

    // ml (margin left) value has to be the same as indention of cards
    return (
        <div
            className={`
              ml-[200px] hidden flex-row items-stretch

              md:flex
            `}
        >
            {VALUES.map((value, index) => (
                <ValueCardDesktop
                    index={index}
                    key={value.id}
                    currentIndex={currentCardIndex}
                    previousIndex={previousCardIndex}
                    onSelect={() => handleSelect(index)}
                    onSpread={handleSpread}
                    {...value}
                />
            ))}
        </div>
    );
};
